import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  tabTitle: {
    color: "#666666",
    fontSize: theme.typography.pxToRem(16),
    fontStyle: "normal",
    fontFamily: "Lato",
    fontWeight: 400,
    paddingLeft: "4px",
  },
  tabIcon: {
    paddingTop: "6px",
    color: "red",
  },
  tabItemContainer: {
    cursor: "pointer",
    marginRight: "56px",
    marginTop: "10px",
  },
  selectedTab: {
    borderBottom: "3px solid #000000",
    "& .MuiTypography-root": {
      color: "#000000",
    },
    "& path": {
      fill: "#000000",
    },
  },
}));
